export default "__VITE_ASSET__Bm_fftH___"